export const MAIN_SEARCH_FLIGHT_TEST_IDS = {
  // ─── Flight Search Form ───
  formContainer: 'main-search-flight-form-container',

  // ─── Trip Type ───
  tripTypeRadio: 'main-search-flight-trip-type-radio',
  tripTypeOneWay: 'main-search-flight-trip-type-one-way',
  tripTypeRoundTrip: 'main-search-flight-trip-type-round-trip',

  // ─── Origin / Destination ───
  departureInput: 'main-search-flight-departure-input',
  destinationInput: 'main-search-flight-destination-input',
  swapCitiesButton: 'main-search-flight-swap-cities-btn',
  departureSelectorContainer: 'main-search-flight-departure-selector',
  destinationSelectorContainer: 'main-search-flight-destination-selector',

  // ─── Country / City Selector ───
  countryCitySelector: (fieldName: string) => `main-search-flight-country-city-selector-${fieldName}`,

  // ─── Date Picker ───
  dateRangePicker: 'main-search-flight-date-range-picker',

  // ─── Guest Selector ───
  guestSelectorTrigger: 'main-search-flight-guest-selector-trigger',
  guestSelectorPopover: 'main-search-flight-guest-selector-popover',
  guestSelectorConfirmButton: 'main-search-flight-guest-selector-confirm-btn',
  guestAdultDecrement: 'main-search-flight-guest-adult-decrement',
  guestAdultIncrement: 'main-search-flight-guest-adult-increment',
  guestAdultValue: 'main-search-flight-guest-adult-value',
  guestTeenagerDecrement: 'main-search-flight-guest-teenager-decrement',
  guestTeenagerIncrement: 'main-search-flight-guest-teenager-increment',
  guestTeenagerValue: 'main-search-flight-guest-teenager-value',
  guestChildDecrement: 'main-search-flight-guest-child-decrement',
  guestChildIncrement: 'main-search-flight-guest-child-increment',
  guestChildValue: 'main-search-flight-guest-child-value',
  guestInfantDecrement: 'main-search-flight-guest-infant-decrement',
  guestInfantIncrement: 'main-search-flight-guest-infant-increment',
  guestInfantValue: 'main-search-flight-guest-infant-value',
  guestValidationError: 'main-search-flight-guest-validation-error',

  // ─── AAdvantage Checkbox ───
  aadvantageCheckbox: 'main-search-flight-aadvantage-checkbox',

  // ─── Promo Code ───
  promoCodeSection: 'main-search-flight-promo-code-section',
  promoCodeDesktop: 'main-search-flight-promo-code-desktop',
  promoCodeMobile: 'main-search-flight-promo-code-mobile',

  // ─── Actions ───
  redoSearchButton: 'main-search-flight-redo-search-btn',
  searchButton: 'main-search-flight-search-btn',
} as const;
